'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fireEvent = fireEvent;
/**
 * @description Fires the given event on the given element.
 * @summary
 * Fires the given event on the given element.
 * If a payload is supplied as third argument, then it is added to the event
 * as `detail` property.
 *
 * **Browser Support**
 *
 * The method for firing custom events used in this instance is supported by all
 * modern browser including IE9+ and Opera mini.
 *
 * @example
 * import { fireEvent } from '@nimius/event-utility'
 *
 * // Fire a 'click' event on the input[type=file] when the user clicks
 * // the button in order to open the file-chooser dialog.
 * button.addEventListener('click', () => {
 *    fireEvent(container.querySelector('input[type=file]'), 'click')
 * })
 *
 * @example
 * import { fireEvent } from '@nimius/event-utility'
 *
 * // Fire a custom event with some payload
 * const payload = { foo: 'bar' }
 * button.addEventListener('custom_event', e => console.log(e.detail.foo))
 * fireEvent(button, 'custom_event', payload);
 * // => bar
 *
 * @param {HTMLElement} element - Element on which the event should be fired
 * @param {string} eventName - Name of the event that should be fired.
 * @param {Object} [detailPayload] - Payload that should be added to the event as `detail` attribute.
 * @returns {boolean}
 */
function fireEvent(element, eventName) {
  var detailPayload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  /*
   * Initializing the event
   * NOTE: The `new CustomEvent()` constructor is not used in this instance
   *       because it is not supported by IE9 & IE10.
   *       Instead, the universally supported `createEvent` and `initCustomEvent` methods
   *       are being used.
   */
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(eventName, true, true, detailPayload);

  return !element.dispatchEvent(event);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/event-utility/src/fire-event.js
// module id = 126
// module chunks = 5